import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { BrandHeader } from '@fuww/library/src/CompanyProfile';
import LayoutComponent from '@fuww/library/src/Layout';
import Anchor from '@fuww/library/src/Anchor';
import DynamicEmailConfirmationAlert
  from '../../Users/DynamicEmailConfirmationAlert';
import HeaderImage from '../../Company/HeaderImage';
import messages from '../../../lib/messages.json';
import Image from '../../Image';

const Company = ({
  profile,
  children,
  ...properties
}) => {
  const intl = useIntl();

  const {
    page: {
      title,
    },
    company: {
      logoUrls,
      url,
    },
  } = profile;

  return (
    <LayoutComponent
      overflow="visible"
      layoutMaxWidth="100vw"
      layoutMarginBottom="0"
      sitewideAlert={(<DynamicEmailConfirmationAlert />)}
      header={(
        <>
          <HeaderImage profile={profile} />
          {title && (
          <BrandHeader
            logo={logoUrls[0] && (
              <Anchor
                styled
                href={url}
              >
                <Image
                  src={logoUrls[1]}
                  alt={`Logo ${title}`}
                  height="102px"
                  sizes="102px"
                  width="102px"
                  srcSet={`${logoUrls[1]
                  } 102w, ${logoUrls[2]
                  } 204w, ${logoUrls[3]
                  } 306w`}
                  placeholder={logoUrls[0]}
                  finalFetchpriority="high"
                  placeholderFetchpriority="high"
                  preload
                />
              </Anchor>
            )}
            brandName={
              intl.formatMessage(
                messages['fashion-finder.title'],
              )
            }
          />
          )}
        </>
    )}
      {...properties}
    >
      {children}
    </LayoutComponent>
  );
};

Company.propTypes = {
  profile: PropTypes.shape({
    page: PropTypes.shape({
      title: PropTypes.string,
    }),
    company: PropTypes.shape({
      logoUrls: PropTypes.arrayOf(PropTypes.string),
      url: PropTypes.string,
    }),
  }).isRequired,
  children: PropTypes.node.isRequired,
};

export default Company;
